<template>
  <a :href="url" target="_blank">{{text}}</a>
</template>

<script>
import config from "../../config";

export default {
  props: ["chain", "text", "type", "to"],
  data() {
    return {
      url: ""
    };
  },
  created() {
    let url = "";
    if (config.CHAIN === "eth") {
      url = "https://etherscan.io/" + this.type + "/" + this.to;
    } else {
      url = "https://sidechain.aira.life/";
      if (this.type === "address") {
        url += "account";
      } else if (this.type === "tx") {
        url += "tx";
      } else if (this.type === "block") {
        url += "block";
      }
      url += "/" + this.to;
    }
    this.url = url;
  }
};
</script>
